// This must always be first
import "./require";

// Third-party dependencies
import "popper.js";
import "bootstrap";
import "lazysizes";
import "lazysizes/plugins/object-fit/ls.object-fit.js";
import "lazysizes/plugins/parent-fit/ls.parent-fit.js";
import "lazysizes/plugins/respimg/ls.respimg.js";
import "fluidbox";
import "smartmenus";
import "smartmenus/dist/addons/bootstrap-4/jquery.smartmenus.bootstrap-4.js";

// Theme scripts
import { AdvancedForm } from "./advanced-forms";
// open product in a normal way with no modal
//import { iframeResize, loadInFrame } from "./ajax-iframe";
import { getScrollbarWidth } from "./css-vars";
import { better_wpcf7_forms } from "./forms";
import { ajax_search } from "./search";
import { woocommerceFeatures } from "./woocommerce";
import { shareButtons } from "./share-buttons";
import "./extras.js";


const $ = jQuery;

$( () => {

  $( 'form.af-form' ).each( function ( this: HTMLFormElement ) {
    new AdvancedForm( this );
  } );

  document.documentElement.style.setProperty( '--scrollbar-width', getScrollbarWidth() + 'px' );

  ajax_search();
  woocommerceFeatures();
  //loadInFrame(); // loads content into iframe
  //iframeResize(); // Automatically resizes iframes
  shareButtons();

  better_wpcf7_forms();
  $( '.gallery a.thumbnail' ).fluidbox();
  $( '.gallery a.thumbnail img' ).each( function ( this: HTMLImageElement ) {
    if ( this.src !== this.getAttribute( 'src' ) ) {
      $( this ).replaceWith( $( this.outerHTML ) );
    }
  } );

  //product archive collapse
  $('body.archive.woocommerce .term-description > p').not(':nth-child(1)').addClass('collapse-wrap');
  $( '.collapse-wrap' ).wrapAll( '<div class="collapse" id="collapseExample"/>' );
  $('body.archive.woocommerce .term-description > p:nth-child(1)').after('<a class="show-more-link" data-toggle="collapse" href="#collapseExample">show more</a>');


  // flyout menu
  $( '.navbar-collapse.width' ).on( 'show.bs.collapse hide.bs.collapse', function ( e ) {
    $( 'body' ).toggleClass( 'menu-visible' );
  } );

  //top menu size when scrolling
  $( window ).on( 'resize scroll', function ( e ) {
    if ( $( window ).scrollTop() > $( '.page-header .fixed-top' ).height() && !$( '.page-header .fixed-top' ).is( '.scroll' ) ) {
      $( '.page-header .fixed-top' ).addClass( 'scroll' );
    } else if ( $( window ).scrollTop() < $( '.page-header .fixed-top' ).height() && $( '.page-header .fixed-top' ).is( '.scroll' ) ) {
      $( '.page-header .fixed-top' ).removeClass( 'scroll' );
    }
  } );

  //search
  $(this).removeClass('open');
  $('li.search a').on('click', function(e) {
    $(this).toggleClass('open');
    $('.header-search-box').toggleClass('open');
  });

} );
